const { getAllCookies } = require('../cookies')
const { getUrlSearchParams } = require('./get-url-search-params')
const { parseTracking } = require('./parse-tracking')
const { trackingParams } = require('./tracking-params')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {object} query
 * @returns {{}}
 */
function setTracking (query = {}) {
  const tracking = {}
  const values = {
    ...getAllCookies(),
    ...getUrlSearchParams(),
    ...query
  }

  for (const param in trackingParams) {
    const item = trackingParams[param]

    const name = item.alternativeKeys
      ? [item.key, ...item.alternativeKeys].find(key => values?.[key])
      : item.key

    const value = values?.[name]
    if (value && !tracking[param]) {
      tracking[param] = value
    }
  }

  return parseTracking(tracking)
}

module.exports = { setTracking }
